import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const EMPTY = { associations: [], schools: [], default_association_id: null };
const OrgsContext = createContext({ orgs: EMPTY, reloadOrgs: () => {} });

// Single shared association/school list for every dropdown in the admin area.
export function OrgsProvider({ children }) {
  const { user } = useAuth();
  const [orgs, setOrgs] = useState(EMPTY);

  const reloadOrgs = useCallback(async () => {
    try { const { data } = await api.get("/orgs"); setOrgs(data); return data; }
    catch { return EMPTY; }
  }, []);

  useEffect(() => { if (user) reloadOrgs(); }, [user, reloadOrgs]);

  const createAssociation = async (name) => {
    const { data } = await api.post("/associations", { name });
    await reloadOrgs();
    return data.id;
  };
  const createSchool = async (name, association_id) => {
    const { data } = await api.post("/schools", { name, association_id });
    await reloadOrgs();
    return data.id;
  };

  return (
    <OrgsContext.Provider value={{ orgs, reloadOrgs, createAssociation, createSchool }}>
      {children}
    </OrgsContext.Provider>
  );
}

export const useOrgs = () => useContext(OrgsContext);
